import { useContext } from 'react'
import { useNavigate } from 'react-router'
import { MentorLocalizationContext } from 'src/mentor/context/MentorLocalizationContext'
import { MentorClinicsContext } from 'src/mentor/layout'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { HomePageItem } from '../MentorHomePage/MentorHomepageStyles'

// Report LINKS only. The inline stats table that used to render below these tiles moved to
// Stats → table view → "Across Locations" (ModernizedClinicReportsPage), so clinic reporting
// lives in one place; owners reach it via the "Stats" card / route (/mentor-home/stats).
export default function ClinicOwnerReport() {
  const clinicsContext = useContext(MentorClinicsContext) || {}
  const { associatedClinicBrands } = clinicsContext
  const localizedData = useContext(MentorLocalizationContext)
  const navigate = useNavigate()

  const translatedStrings = localizedData?.localizedData?.strings?.homePage

  // Support enables the owner business surfaces per brand (ClinicBrand.ownerPortalSettings).
  // Default is OFF: a tile shows only when ANY loaded brand has the surface explicitly on —
  // the backend enforces the flags on the underlying endpoints either way.
  const brandSurfaceEnabled = (key) =>
    Array.isArray(associatedClinicBrands) &&
    associatedClinicBrands.some((brand) => brand?.ownerPortalSettings?.[key] === true)
  const payoutReportsEnabled = brandSurfaceEnabled('showPayoutReports')
  const businessModelsEnabled = brandSurfaceEnabled('showBusinessModels')

  return (
    <div className="px-2">
      <h2 className="mb-4">Reports (visible to clinic owners only)</h2>
      <div className="d-flex flex-wrap-1 w-100 gap-4">
        {getAllRolesInBoolean().isDoctor && (
          <HomePageItem
            otherColor="linear-gradient(46deg, #b961b3 0%, #4639a2 100%)"
            onClick={() => navigate('/mentor-home/fee-collection-report')}
          >
            {translatedStrings?.fee_collection_report || 'Clinic - Fees & Report'}
          </HomePageItem>
        )}
        {getAllRolesInBoolean().isClinicOwner &&
          getAllRolesInBoolean().isDoctor &&
          payoutReportsEnabled && (
            <HomePageItem
              otherColor="linear-gradient(46deg, #0e0d4f 0%, #4a77b8 100%)"
              onClick={() => navigate('/mentor-home/clinic-payout-reports/consultation')}
            >
              {'Consultation Payout Reports'}
            </HomePageItem>
          )}
        {getAllRolesInBoolean().isClinicOwner &&
          getAllRolesInBoolean().isDoctor &&
          payoutReportsEnabled && (
            <HomePageItem
              otherColor="linear-gradient(46deg, #133320 0%, #41ac51 100%)"
              onClick={() => navigate('/mentor-home/clinic-payout-reports/therapy')}
            >
              {'Therapy Payout Reports'}
            </HomePageItem>
          )}
        {getAllRolesInBoolean().isClinicOwner &&
          getAllRolesInBoolean().isDoctor &&
          businessModelsEnabled && (
            <HomePageItem
              otherColor="linear-gradient(46deg, #133320 0%, #41ac51 100%)"
              onClick={() => navigate('/mentor-home/business-models')}
            >
              {'Business Models'}
            </HomePageItem>
          )}
      </div>
    </div>
  )
}
